<template>
    <main class="register-login">
        <div class="container">
            <Header />
            <FormLogin 
                :isAnalist="isAnalist"
            />
        </div>
    </main>
</template>

<script>
import FormLogin from "@/components/signupAndLogin/FormLogin";
import Header from "@/components/signupAndLogin/Header";

export default {
    name: "Login",
    components: { Header, FormLogin },
    props: {
        isAnalist: {
            type: Boolean,
            default: false
        }
    }
};
</script>
